export const POPOVER_SHADOW = "0px 0px 40px 0px rgba(125, 125, 125, 0.1)" 
